import { StyleSheet, Platform } from "react-native";
import AppTheme from "../../AppTheme";

const integrationStyles = StyleSheet.create({
  container: {
    backgroundColor: "#FFF",
  },
  shadow: {
    shadowOffset: { width: 0, height: 4 },
    shadowColor: "#000",
    shadowRadius: 3,
    elevation: 5,
    shadowOpacity: 0.1,
  },
  header: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 20,
    lineHeight: 30,
    letterSpacing: 1,
    color: AppTheme.almostBlack,
    textAlign: "center",
  },
  section: {
    paddingHorizontal: 10,
    marginTop: 32,
    minHeight: 200,
  },
  sectionHeader: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.175,
    color: AppTheme.almostBlack,
    textAlign: "center",
    marginBottom: 8,
  },
  row: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    marginBottom: 16,
  },
  icon: {
    width: 30,
    height: 30,
    marginRight: 8,
  },
  rowText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-Regular",
    }),
    fontWeight: "300",
    fontSize: 12,
    lineHeight: 14,
    letterSpacing: 0.5,
    color: AppTheme.almostBlack,
    flex: 1,
  },
  link: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "500",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
    color: AppTheme.DEFAULT_COLOR,
  },
  buttons: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  button: {
    width: 255,
    height: 34,
    paddingHorizontal: 16,
    backgroundColor: "#F3F2F1",
    shadowOpacity: 0.1,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 4 },
    shadowRadius: 5,
    elevation: 5,
    display: "flex",
    //justifyContent: "center",
    alignItems: "center",
    flexDirection: "row",
    marginBottom: 8,
    borderRadius: 4,
  },
  buttonIcon: {
    width: 18,
    height: 18,
    marginRight: 6,
  },
  buttonText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
    color: "#757575",
  },
  greenButton: {
    width: 104,
    height: 32,
    marginBottom: 23,
    backgroundColor: AppTheme.DEFAULT_COLOR,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 6,
    marginTop: 55,
  },
  greenButtonText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
    color: "#FFF",
  },
  skipText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
    color: "#8B92A1",
    marginTop: 8
  },
});

export default integrationStyles;
